import clsx from 'clsx'
import type { PropsWithChildren, RefAttributes } from 'react'
import React from 'react'
import styled from 'styled-components'

const TRANSITION_DURATION = 300

const Container = styled.div`
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows ${TRANSITION_DURATION}ms;

  &.expanded {
    grid-template-rows: 1fr;
  }
`

const Content = styled.div`
  overflow: hidden;
  opacity: 0;
  transition: opacity ${TRANSITION_DURATION}ms;

  &.expanded {
    opacity: 1;

    &.transition-delayed {
      transition-delay: ${TRANSITION_DURATION / 2}ms;
    }
  }
`

interface Props extends PropsWithChildren, RefAttributes<HTMLDivElement> {
  expanded: boolean
  /**
   * @default default
   */
  contentTransition?: 'default' | 'delayed'
  className?: string
}

function Expander({
  children,
  expanded,
  contentTransition,
  className,
  ref,
}: Props) {
  return <Container ref={ref} className={clsx(className, { expanded })}>
    <Content className={clsx(`transition-${contentTransition}`, { expanded })}>
      {children}
    </Content>
  </Container>
}

export default Expander
